import { ContentTypeCondition } from '@plone/volto/helpers/Slots';
import SummaryInfos from '@redturtle/iovisit-theme/components/Views/Itinerary/SummaryInfos';
import PreviewImageCredits from '@redturtle/iovisit-theme/components/PreviewImageCredits/PreviewImageCredits';

// Predicate: tutti tranne LRF
export const notLRF = ({ content }) => content?.['@type'] !== 'LRF';

// Predicate: solo se il content ha preview_caption
export const hasPreviewCaption = ({ content }) =>
  Boolean(content?.preview_caption);

export default function IoVisitSlots(config) {
  config.registerSlotComponent({
    slot: 'leadimage-more',
    name: 'itinerary-infos',
    component: SummaryInfos,
    predicates: [ContentTypeCondition(['Itinerary'])],
  });

  config.registerSlotComponent({
    slot: 'preview-image-caption',
    name: 'preview-image-caption-slot',
    component: PreviewImageCredits,
    predicates: [hasPreviewCaption],
  });

  return config;
}
